export default __webpack_public_path__ + "static/media/idea-card.3bea8f65.jpg";